module.exports = __webpack_public_path__ + "static/media/work-img7.538f0586.jpg";